module.exports = __webpack_public_path__ + "static/media/move_down.e4c14d85.svg";